import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
const NO_FIELDS = [];
const FIVE_MINUTES = 5 * 60 * 1000;
export function useClientReferenceFieldNames() {
    let { refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { data } = useQueryState({
        queryKey: [
            QueryKeys.ClientReferenceFieldNames
        ],
        queryFn: ()=>api.client.getReferenceFieldNames(),
        staleTime: FIVE_MINUTES,
        refreshOnHookMount
    });
    return {
        fields: data !== null && data !== void 0 ? data : NO_FIELDS
    };
}
